import { Affine, type AffineMatrix } from "./Affine";
import type { ReversePixelMapperFactory } from "../../ReversePixelMapperFactory";

/**
 * Creates affine distortion using forward affine matrix.
 *
 * @see https://imagemagick.org/api/MagickCore/distort_8c_source.html#l00609 Generating inverted affine distortion matrix from forward affine matrix at ImageMagick source
 */
export class AffineProjectionFactory
  implements ReversePixelMapperFactory<AffineMatrix>
{
  /**
   * Returns Affine instance.
   *
   * @param matrix Affine projection coefficients: [sx, ry, rx, sy, tx, ty].
   */
  create(matrix: AffineMatrix): Affine {
    // arguments order is different from actual affine matrix for compatibility with ImageMagick
    // AffineProjection distortion arguments order.
    const [sx, ry, rx, sy, tx, ty] = matrix;
    return Affine.fromForwardMatrix([sx, rx, tx, ry, sy, ty]);
  }
}
